<p class="welcome-message">Welcome to QuizTime!</p>
